import type { GlobalWidget } from '@/app/widgets'

/**
 * The assistant (design canvas "AI assistant", 2026-10-25): the floating pill at the bottom of every vertical-layout
 * page, the docked panel on the right and its expanded split. A global widget, so the thread survives navigation;
 * the widget itself hides on the full and onboarding layouts. Clients and Staff only: a Freelancer (candidate app,
 * employee portal) has no assistant yet.
 */
const widgets: GlobalWidget[] = [
  {
    id: 'assistant',
    load: () => import('./components/AssistantWidget.vue'),
    when: ({ signedIn, userType }) => signedIn && (userType === 'Client' || userType === 'Staff'),
  },
]

export default widgets
